import { Box, Card, Grid, Switch, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { useCreateFeedMutation } from '../../api/apiSlice';
import FormikButton from '../../components/formik/FormikButton';
import FormikInput from '../../components/formik/FormikInput';
import Screen from '../../components/fragments/Screen';
import ImageUpload from '../../components/ui/ImageUpload';
import Form from '../../components/utilities/Form';
import errorSnackbar from '../../utils/errorSnackbar';

const validate = Yup.object().shape({
    text: Yup.string().min(2).max(500).required().label('Post Content'),
    images: Yup.mixed().label('Profile Image'),
});

export default function CreatePostScreen() {
    const [publicPost, setPublicPost] = useState(false);

    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const [createFeed, { isLoading }] = useCreateFeedMutation();

    return (
        <Screen title={'Create Post'}>
            <Grid item xs={12}>
                <Form
                    validationSchema={validate}
                    initialValues={{ text: '', images: [] }}
                    onSubmit={async (vals) => {
                        const { data, error } = await createFeed({
                            post: vals?.text,
                            images: vals?.images,
                            publicPost,
                        });

                        errorSnackbar(error, enqueueSnackbar);

                        if (data) {
                            enqueueSnackbar('Post created successfully');
                            navigate('/feed');
                        }
                    }}
                >
                    <ImageUpload name="images" limit={3} />
                    <FormikInput
                        multiline
                        rows={4}
                        placeholder="What's on your mind?"
                        name="text"
                    />
                    <Card sx={{ mb: 2 }} variant="outlined">
                        <Box
                            sx={{ my: 1, mx: 2 }}
                            className="d-flex align-items-center justify-content-between"
                        >
                            <Typography noWrap={false}>
                                Make this post public
                            </Typography>
                            <Switch
                                checked={publicPost}
                                onChange={() => setPublicPost(!publicPost)}
                            />
                        </Box>
                    </Card>
                    <FormikButton
                        className="w-100"
                        loading={isLoading}
                        variant="contained"
                    >
                        Publish Post
                    </FormikButton>
                </Form>
            </Grid>
        </Screen>
    );
}
